import { VTooltip } from 'v-tooltip';
import { VueConstructor } from 'vue';

export default function registerVTooltip(vue: VueConstructor, name = 'v-tooltip'): void {
  vue.directive(name, VTooltip);
}
